export default __webpack_public_path__ + "locales/sq-AL/ConvertPasswordDialog.json?hash=643b5d4c0c9d600d99d38c218648c3d7";